export default [
    {
        path: '/waybills',
        name: 'WaybillList',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Waybills',
            fullWidth: true,
        },
        components: {
            default: () => import('@views/waybill/WaybillListView.vue'),
        },
    },
    {
        path: '/waybills/:id',
        name: 'WaybillBuilder',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Waybill builder',
            fullWidth: true,
        },
        components: {
            default: () => import('@views/waybill/WaybillBuilderView.vue'),
        },
    },
];
